import React, { useContext } from 'react';
import { QuestRoute } from '../../../api/QuestRoutes';
import { useParams } from 'react-router-dom';
import { useGlobalState } from '../../../stateProvider/StateProvider';
import PageBreak from '../../../layout/PageBreak';
import FormSetting from '../../../layout/FormSetting';
import HamQuest from '../../../api/HamQuestGiver';
import Input from '../../../forms/Input';
import Select from '../../../forms/Select';
import { HSOptions } from '../../../../constants/HSOptions';
import Checkbox from '../../../forms/Checkbox';
import AutoSelectAndUpgrade from '../../../forms/formComponents/AutoSelectAndUpgrade';
import Button from '../../../forms/Button';
import { addCardToAccount } from '../../../PaymentForm';
import PhoneNumberInput from '../../../forms/formComponents/PhoneNumberInput';
import { LoyaltyUserContext } from '../LoyaltyUser';
import Row from '../../../layout/Row';
import { addSuffix, generateId, inputDate, shortHandDate } from '../../../utility/functions';
import { BillingStartDate, getBD, getBSD } from '../WCSignUp';
import Modal, { ModalFlow } from '../../../Modal';
import Col from '../../../layout/Col';
import Form from '../../../forms/Form';
import ModalFactory from '../../../Modal';

const Management = ({ userData, ...props }) => {
    const {
        state: {
            active_user,
            states
        },
    } = useGlobalState();

    const context = useContext(LoyaltyUserContext);

    const { loyaltyAccountId } = useParams();

    const passMaxUses = [{ label: context.user.passMaxUsePeriod, value: context.user.passMaxUsePeriod }, ...HSOptions.expressPass.maxUsePeriod];
    const receiptMode = [{ label: context.user.receiptMode, value: context.user.receiptMode }, ...HSOptions.expressPass.receiptMode];

    const CC = context.user.cardOnFile;


    context.user.billingStartDate = inputDate(getBSD(context.user.billingDay, context.user.billingStartDate))

    const currentDate = new Date();

    if (!context.user.billingDay) {
        context.user.billingDay = getBD();
    }

    const activateAccount = () => {
        const lastBilling = new Date(context.user.lastInvoiceDate);

        ModalFactory.confirmAndProcess({
            confirmation: {
                title: `Reactivation`,
                body: (
                    <Col>
                        <span>Reactivate {context.user.accountName}'s Wash Club?</span>
                        <span>Their last charge was <b>{shortHandDate(lastBilling)}</b>.</span>
                    </Col>
                ),
            },
            promise: {
                title: 'Reactivating ExpressPass',
                body: `Reactivating, please wait.`,
                callback: () => HamQuest.get(QuestRoute.expressPass.reactivation(context.user.loyaltyAccountId))
            },
            confirmed: {
                title: 'Success',
                body: `${context.user.accountName}'s successfully reactivated.`,
                type: 'success'
            },
            finally: () => context.refreshUser()
        })
    }

    const resignUp = async () => {
        const lastBilling = new Date(context.user.lastInvoiceDate);

        const statusOptions = HSOptions.washClub.status
            .filter(e => e.value === 'Active' || e.value === 'EndBillingPending')
            .map(e => ({
                ...e,
                disabled: false,
            }))

        if (!CC.onFile || context.user.accountStatus === 'CreditHold') {
            await addCardToAccount(context.user.customerId)
                .then(() => context.refreshUser())
                .catch(ModalFactory.catch)
            const res = !CC.onFile ? true : await ModalFactory.confirmation({
                title: 'Add a Card?',
                body: 'Would you like to add a new Credit Card to this account?',
                closeAfter: true
            })

            if (res)
                await addCardToAccount(context.user.customerId)
                    .then(() => context.refreshUser())
                    .catch(ModalFactory.catch)
                }

        if (lastBilling >= new Date().setMonth(currentDate.getMonth() - 1)) {
            activateAccount();
            return;
        }

        const id = generateId();
        ModalFactory.show({
            id,
            title: 'Re-Sign Up',
            body: () => {
                return (
                    <Form
                        inputs={{
                            status: '',
                            billingDay: context.user.billingDay,
                            billToday: false,
                            billingStartDate: inputDate(getBSD(context.user.billingDay)),
                        }}
                        onSubmit={e => (
                            HamQuest.post(QuestRoute.expressPass.resignUp(context.user.loyaltyAccountId), { ...e })
                                .then(() => context.refreshUser())
                                .then(res => {
                                    ModalFactory.update({
                                        id,
                                        title: 'Success!',
                                        body: `${context.user.accountName} signed up successfully.`,
                                    })
                                })
                                .catch(ModalFactory.catch)
                        )}
                    >
                        {({ values, setValue }) => {
                            return (
                                <>
                                    <Select
                                        label='Status'
                                        name='status'
                                        options={statusOptions}
                                        required
                                    />
                                    <Input
                                        label='Price'
                                        value={context.user.billingAmount}
                                        readOnly
                                        type='price'
                                        required
                                    />
                                    {(
                                        <>
                                            <Checkbox
                                                label='Charge Customer today?'
                                                name='billToday'
                                                callback={e => {
                                                    const day = e ? getBD() : context.user.billingDay
                                                    setValue('billingDay', day)

                                                    const val = values.billingStartDate.split('-');
                                                    val[2] = day.toString().padStart(2, '0');
                                                    setValue('billingStartDate', val.join('-'))
                                                }}
                                            />
                                            <Input
                                                label='Billing Day'
                                                name='billingDay'
                                                disabled
                                                required
                                            />
                                            <BillingStartDate values={values} setValue={setValue} />
                                        </>
                                    )}
                                </>
                            )
                        }}
                    </Form >
                )
            }
        })
    }

    return (
        <PageBreak>
            <FormSetting
                label='Settings'
                inputs={{ ...context.user }}
                onSubmit={e => HamQuest.put(QuestRoute.loyaltyUser.info(loyaltyAccountId), { ...e })}
                controls={[
                    // REMOVED FOR DEMO context.user.accountStatus === 'CreditHold' || context.user.accountStatus === 'Inactive' ? <Button label='Resign Up' onClick={resignUp} key={generateId()} /> : null
                ]}
                text='Update'
                editable
            >
                {({ values, setValue, editing }) => (
                    <>
                        <Input
                            label='Account Name'
                            name='accountName'
                            required
                        />
                        <Select
                            label='Account Status'
                            name='accountStatus'
                            options={HSOptions.washClub.status}
                            // REMOVED FOR PRODUCTION disable={context.user.accountStatus === 'CreditHold'}
                            required
                        />
                        <Row wrap>
                            <Select
                                label='Billing Type'
                                name='billingType'
                                options={HSOptions.user.recurringBilling}
                                required
                            />
                            <Select
                                label='Max Use Period'
                                name='passMaxUsePeriod'
                                options={passMaxUses}
                                required
                            />
                            {/* <Input
                                label='Billing Day'
                                value={addSuffix(context.user.billingDay)}
                                disabled
                                standalone
                            /> */}
                        </Row>

                        <Row wrap>
                            <Input
                                label='Billing Day'
                                name='billingDay'
                                value={addSuffix(values.billingDay)}
                                disabled
                                standalone
                            />
                            {values.accountStatus === 'Active' && (
                                <BillingStartDate values={values} setValue={setValue} editing={editing} />
                            )}
                        </Row>

                        <Input
                            label='Pass Max Uses'
                            name='passMaxUses'
                            type='number'
                            required
                        />
                        <Checkbox
                            label='Use Default Pass Reuse Time'
                            name='useDefaultPassReuseTime'
                        />
                        <Input
                            label='Pass Reuse Inhibit Time (min)'
                            name='passReuseInhibitTime'
                            type='numbers'
                            disabled={values.useDefaultPassReuseTime}
                            required
                        />
                        <AutoSelectAndUpgrade />
                        <Select
                            label='Receipt Mode'
                            name='receiptMode'
                            options={receiptMode}
                            required
                        />
                    </>
                )}
            </FormSetting>

            <FormSetting
                label='Contact Info'
                inputs={{ ...context.user.accountContact }}
                onSubmit={e => HamQuest.put(QuestRoute.loyaltyUser.info(loyaltyAccountId), { ...e })}
                text='Update'
                editable
            >
                {({ values }) => (
                    <>
                        <Input
                            label='First Name'
                            name='firstName'
                            required
                        />
                        <Input
                            label='Last Name'
                            name='lastName'
                            required
                        />
                        <PhoneNumberInput
                            name='phone'
                        />
                        <Input
                            label='Email'
                            name='email'
                            type='email'
                            required
                        />
                    </>
                )}
            </FormSetting>

            <FormSetting
                label='Notifications'
                inputs={{ ...context.user }}
                onSubmit={e => HamQuest.put(QuestRoute.loyaltyUser.info(loyaltyAccountId), { ...e })}
                text='Update'
                editable
            >
                {({ values }) => (
                    <>
                        {/* <Input
                            label='Email Invoice Receipt'
                            name='emailInvoiceReceipt'
                            required
                        /> */}
                        <Checkbox
                            label='Use Contact Email'
                            name='useContactEmail'
                            required
                        />
                    </>
                )}
            </FormSetting>

            <FormSetting
                label='Credit Card'
                controls={[<Button onClick={() => addCardToAccount(context.user.customerId).then(() => context.refreshUser())}>{CC.maskedCardNumber ? 'Update ' : 'Add '} Card</Button>]}
                localForm
            >
                {(
                    CC.maskedCardNumber ? (
                        <>
                            <Input
                                label='Card Type'
                                value={CC.cardType}
                                disabled
                                standalone
                            />
                            <Input
                                label='Card Number'
                                value={CC.maskedCardNumber}
                                disabled
                                standalone
                            />
                            <Input
                                label='Expiration'
                                value={`${CC.expirationMonth}-${CC.expirationYear}`}
                                disabled
                                standalone
                            />
                        </>
                    ) : (
                        <div>
                            No Card on file
                        </div>
                    )
                )}
            </FormSetting>
        </PageBreak>
    );
}

export default Management;
